import fetchApi from 'components/utils/fetch_api'

const create = beneficiaryID => {
  return fetchApi(`notifications/beneficiaries/ubs/${beneficiaryID}/created`, { method: 'POST' })
}

export { create }
